<template>
	<div
		class="ms-cell-editor"
		:class="[browserInfo && browserInfo.isFirefox && dataRow[col.dataField] ? 'ms-cell-editor-firefox' : '']"
	>
		<div
			v-show="!isSelected || readOnly"
			class="flex-center"
			:class="{
				'edit-disabled': readOnly,
				'ms-editor-text': editable,
				'editor-input isValid': cellErrorProvider.isValid,
				'text-editor': customProperty && customProperty.tooltip,
			}"
			v-tooltip="
				col.tooltip
					? {
							content: $options.filters.formatData(dataRow[col.dataField], {
								formatType: col.formatType,
								enumName: col.enumName,
							}),
							placement: 'bottom',
					  }
					: customProperty && customProperty.tooltip
					? {
							content: dataRow[col.dataField],
							placement: 'bottom',
					  }
					: null
			"
		>
			<div class="editor-display">
				<span>{{
					dataRow[col.dataField]
						| formatData({
							formatType: col.formatType,
							enumName: col.enumName,
						})
				}}</span
				>
			</div>

			<div
				class="icon-input float-right"
				v-tooltip="{ content: cellErrorProvider.message, classes: 'error' }"
				v-if="cellErrorProvider.isValid"
			>
				<div class="mi mi-24 mi-red-tick"></div>
			</div>
		</div>
		<div
			class="ms-editor w-full h-full"
			ref="editor"
			v-show="isSelected && !readOnly && editable"
		></div>
	</div>
</template>
<script>
import msInput from '@/components/msinput/msInput.vue';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import browserInfoMixin from '@/mixins/common/browserInfoMixin';
import Vue from 'vue';
import { setTimeout } from 'timers';
export default {
	name: 'msCellInstruction',
	extends: msBaseComponent,
	mixins: [browserInfoMixin],
	props: {
		col: {},
		dataRow: {},
		rowIndex: {
			default: 0,
			type: Number,
		},
		colIndex: {
			default: 0,
			type: Number,
		},
		//Thuộc tính để cấu hình cho phép sửa trên grid hay không
		editable: {
			default: true,
			type: Boolean,
		},
		rowSelected: {
			default: null,
		},
		isBlurAction: {
			default: true,
			type: Boolean,
		},
		customProperty: {
			default: () => {},
			type: Object,
		},
		//Thông tin cần thiết mà grid truyền xuống component con
		gridInfo: {},
	},
	components: {
		msInput,
	},
	computed: {
		readOnly() {
			const me = this;
			if (!me.editable) {
				return true;
			}
			if (me.col && typeof me.col.readOnly == 'function') {
				return me.col.readOnly(me.dataRow);
			} else {
				return me.col.readOnly;
			}
		},
	},
	mounted() {
		const me = this;
		let watchName = 'dataRow.' + me.col.dataField;
		me.$watch(watchName, function (newVal, oldVal) {
			me.validateCell();
		});
	},
	created() {
		this.columnInfo = this.col;
	},
	beforeDestroy() {},
	data() {
		return {
			isSelected: false,
			cellErrorProvider: {},
			componentId: '',
			currentItem: {},
			columnInfo: {},
			metaData: {},
		};
	},
	watch: {
		isSelected: {
			handler(newVal, oldVal) {
				const me = this;
				if (newVal == false) {
					if (me.col.__editor) {
						if (me.col.__editor.errorProvider) {
							me.col.__editor.errorProvider = {};
						}
					}
					me.$nextTick(() => {
						me.validateCell();
					});
				} else {
					if (me.$el) {
						let content = me.$el.closest('.ms-content--table');
						if (content) {
							if (
								me.$el.getBoundingClientRect().right >=
								content.getBoundingClientRect().right
							) {
								content.scrollLeft += me.$el.getBoundingClientRect().x - 20;
							}
						}
					}
				}
			},
		},
		'col.rules': {
			handler(newVal, oldVal) {
				const me = this;
				if (!newVal) {
					me.$nextTick(() => {
						me.validateCell();
					});
				}
			},
		},
	},
	methods: {
		validateComponent() {
			const me = this;
			if (!me.readOnly) {
				let col = me.col,
					rulesValidate = null,
					ret = false;
				let rules = col.rules;
				if (col.rules && typeof col.rules == 'function') {
					rules = col.rules(me.dataRow);
				}
				// Check valid theo cột dữ liệu trên dòng
				if (col.validBy) {
					let status = me.dataRow[col.validBy] || me.dataRow['rules'];
					if (!status) {
						return;
					}
				}
				if (rules) {
					let listRules = rules.split('|');
					for (let i = 0; i < listRules.length; i++) {
						me.setMetaData();
						ret = !me.validateRule(
							listRules[i],
							me.dataRow[col.dataField],
							col.__editor,
							null,
							false,
							me.metaData
						);
						if (ret) {
							rulesValidate = listRules[i];
							break;
						}
					}
					me.setValid(ret, rulesValidate);
				} else {
					if (me.cellErrorProvider && me.cellErrorProvider.rules == 'custom') {
					} else {
						me.cellErrorProvider = {};
					}
				}
			}
		},

		setMetaData() {
			const me = this;
			if (!me.col) {
				me.metaData = {};
				return;
			}
			if (
				me.col.editorProperty &&
				me.col.editorProperty.propsData &&
				me.col.editorProperty.propsData.data &&
				me.col.editorProperty.propsData.data.length > 0 &&
				me.dataRow &&
				!me.dataRow[me.col.dataFieldOther]
			) {
				me.metaData = {
					dataRow: me.dataRow,
					column: me.col,
					newValue: me.dataRow[me.col.dataField],
					cell: me,
					lstData: me.col.editorProperty.propsData.data.map((x) => x.value),
				};
				return;
			}

			me.metaData = {};
		},
		customValidate() {
			const me = this;
		},
		//Hàm validate trên từng cell
		validateCell() {
			const me = this;
			// if (me.checkDataEmpty) {
			// 	return;
			// }
			me.validateComponent();
			me.customValidate();
		},
		setValid(ret, rulesValidate, message) {
			const me = this;
			if (ret) {
				if (message) {
					me.cellErrorProvider.message = message;
				} else if (me.$t('i18nValidate').messages[rulesValidate]) {
					me.cellErrorProvider.message = me
						.$t('i18nValidate')
						.messages[rulesValidate](me.col.title);
				}
				me.$set(me.cellErrorProvider, 'isValid', true);
				me.cellErrorProvider.rules = rulesValidate;
				me.cellErrorProvider.element = me;
			} else {
				me.cellErrorProvider = {};
			}
		},
		//Khởi tạo editor
		//Created by LTDAT(17.06.2020)
		createdEditor() {
			const me = this;
			let editorControl = me.getEditorControl(),
				col = me.col,
				editorExtend = Vue.extend(editorControl),
				editorProperty = me.getEditorProperty(),
				instance = new editorExtend(editorProperty);
			instance.vm = instance.$mount();
			instance.$cell = me;
			//Định nghĩa thêm field sau dùng cho phân biệt các editor
			instance.$componentId = me.$ms.commonFunc.generateUUID();
			instance.$rowIndex = me.rowIndex;
			// me.gridInfo[`__editor_${me.rowIndex}`] = instance;
			col.__editor = instance;
			col[`__editor_${me.rowIndex}`] = instance;

			me.addHandler(instance);
			return instance;
		},

		resetCachedGridEditor(rowIndex) {
			const me = this;
			if (
				!me.gridInfo ||
				!me.gridInfo[`__editor_${rowIndex}_${me.col.dataField}`]
			) {
				return;
			}

			delete me.gridInfo[`__editor_${rowIndex}_${me.col.dataField}`];
		},

		//Điều hướng cho sự kiện change
		changeHandler(value) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: value,
				oldValue: me.dataRow[me.col.dataField],
				cell: me,
			};
			me.$emit('change', metaData);
		},
		//Hàm xử lý sự kiện editor input
		inputHandler(value) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			me.$set(dataRow, col.dataField, value);
			// dataRow[col.dataField] = value;
		},

		//Hàm xử lý sự kiện editor input
		blurHandler(value) {
			const me = this;
			let metaData = {
				dataRow: me.dataRow,
				column: me.col,
				newValue: value,
				oldValue: me.dataRow[me.col.dataField],
				cell: me,
			};
			me.$emit('blur', metaData);
		},

		addHandler(editor) {
			const me = this;
			editor.$cell = editor.$cell || me;
			editor.$on('input', (...args) => {
				if (editor.$cell) {
					editor.$cell.inputHandler(...args);
				}
			});
			editor.$on('change', (...args) => {
				if (editor.$cell) {
					editor.$cell.changeHandler(...args);
				}
			});
			if (me.isBlurAction) {
				editor.$on('blur', (...args) => {
					if (editor.$cell) {
						editor.$cell.blurHandler(...args);
					}
				});
			}
			me.addCustomHandler(editor);
		},
		//Các loại control khác có event có thể Overide hàm này
		//Created by LTDAT(18.06.2020)
		addCustomHandler(editor) {},
		//Lấy loại control
		//Created by LTDAT(17.06.2020)
		getEditorControl() {
			return msInput;
		},
		//Lấy thuộc tính truyền vào trong editor
		//Created by LTDAT(17.06.2020)
		getEditorProperty() {
			const me = this;
			let col = me.col;
			if (me.customEditProperty && typeof me.customEditProperty == 'function') {
				me.customEditProperty(col.editorProperty);
			}
			return col.editorProperty;
		},
		//Sự kiện click vào cell editor
		cellSelected() {
			const me = this;
			let col = me.col,
				editor = col.__editor;
			me.isSelected = true;
			if (!editor && me.$refs.editor) {
				editor = me.createdEditor();
			}
			if (editor) {
				editor.$cell = me;
				me.beforeEdit(editor);
				if (me.$refs.editor) {
					me.$refs.editor.appendChild(editor.$el);
					me.focusEditor(editor);
				}
			}
		},
		//Focus vào editor
		focusEditor(editor) {
			const me = this;
			let input = this.$refs.editor.querySelector('input,textarea');
			setTimeout(() => {
				if (input) {
					input.focus();
					input.select();
				}
			}, 100);
		},
		//Hàm xử lý trước khi edit reset lại các giá trị trong editor cũ
		//Created by LTDAT(17.06.2020)
		beforeEdit(editor) {
			const me = this;
			let dataRow = me.dataRow,
				col = me.col;
			setTimeout(() => {
				if (editor) {
					me.customBeforeEdit();
					if (typeof editor.reset === 'function') {
						editor.reset();
					}
					if (typeof editor.setValue === 'function') {
						editor.setValue(dataRow[col.dataField]);
					}
					if (
						editor.applyValidate &&
						typeof editor.applyValidate == 'function'
					) {
						me.$nextTick(() => {
							editor.applyValidate(me.cellErrorProvider.message);
						});
					}
				}
			});
			me.$emit('rowSelected', me.dataRow);
		},
		customBeforeEdit() {},
	},
};
</script>
<style lang="scss" scoped>
.ms-cell-editor-firefox {
	height: auto !important;
	min-height: 100% !important;
}
.editor-display {
	padding: 6px 8px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 50px;
	overflow: hidden;
}
.mi-icon-error {
	margin-right: 8px;
}
.text-editor {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>
